<template>
  <div>
      <Header>
          <template #title>
              {{ deliveryPartner }}
          </template>
      </Header>

      <PageContainer>
          <div class="iqos-grid">
              <div class="iqos-column">
                <TaxiPricePanel />
              </div>
              <div class="iqos-column">
                
              </div>
          </div>
         
      </PageContainer>
  </div>
</template>

<script>
import TaxiPricePanel from "@/components/delivery/TaxiPricePanel.vue";

export default {
    computed: {
        cafe() {
            return this.$store.state.cafe;
        },
        deliveryPartner() {
            return this.cafe.delivery.service_tag;
        }
    },
    components: {
        TaxiPricePanel
    }
}
</script>

<style>

</style>